/* eslint-disable global-require */
import { getEnvParam } from 'env'
import { SERVICE_MY_RECORD_NAME, SERVICE_NAME } from 'service.js'
import { SERVER_NAME } from 'conf.js'
import { featureFlags } from 'config/feature-flags'
import AllIcon from '@/assets/images/menu/icon-all-menu.svg'
import MyIcon from '@/assets/images/menu/icon-my-menu.svg'
import FavoriteIcon from '@/assets/images/menu/icon-favorite-menu.svg'
import GroupIcon from '@/assets/images/menu/icon-group-menu.svg'
import CategoryIcon from '@/assets/images/icon-tag-24.svg'
import ExportIcon from '@/assets/images/menu/icon-expired-menu.svg'
import MemoIcon from '@/assets/images/icon-pencil-24.svg'
// 방패+체크(기존 icon-setings-security-24 형태를 메뉴 톤 #111827 로 파생 — #1499)
import AuthenticatorIcon from '@/assets/images/menu/icon-authenticator-menu.svg'

const configMap = {}

export const isDevelopJapan =
  process.env.REACT_APP_TARGET === SERVER_NAME.JAPAN_DEV ||
  process.env.REACT_APP_TARGET === SERVER_NAME.JAPAN_STAGING

export const commonMenuList = (i18n, adminConsoleMenuList = null) => {
  return [
    {
      divider: true,
    },
    {
      title: i18n.t('menu.record.all'),
      key: 'allRecords',
      url: '/records/all',
      icon: AllIcon,
    },
    {
      divider: true,
    },
    {
      title: i18n.t(SERVICE_MY_RECORD_NAME, { service: i18n.t(SERVICE_NAME) }),
      key: 'myRecords',
      url: '/records/mine',
      icon: MyIcon,
    },
    {
      title: i18n.t('menu.record.favorites'),
      key: 'favorites',
      url: '/records/favorites',
      icon: FavoriteIcon,
    },

    // 메모 탭 — dev 전용 flag(memoTemplate). OFF 빌드에서는 항목 자체 미포함 (totp 전례와 동형)
    ...(featureFlags.memoTemplate
      ? [
          {
            title: i18n.t('menu.record.memo'),
            key: 'memoRecords',
            url: '/records/memo',
            icon: MemoIcon,
          },
        ]
      : []),

    {
      title: i18n.t('menu.record.expired'),
      key: 'expiredRecords',
      url: '/records/expired',
      icon: ExportIcon,
    },

    // 인증 코드 탭(#1495) — dev 전용 flag. OFF 빌드에서는 항목 자체 미포함
    ...(featureFlags.totpAuthenticator
      ? [
          {
            title: i18n.t('menu.authenticator'),
            key: 'authenticator',
            url: '/records/authenticator',
            icon: AuthenticatorIcon,
          },
        ]
      : []),

    {
      title: i18n.t('menu.groups'),
      key: 'groups',
      icon: GroupIcon,

      children: [
        {
          title: 'group1',
          key: 'group1',
          url: '/records/groups',
        },
      ],
    },

    {
      title: i18n.t('menu.labels'),
      key: 'categories',
      icon: CategoryIcon,

      children: [
        {
          title: 'category1',
          key: 'category1',
          url: '/records/categories',
        },
      ],
    },

    ...(adminConsoleMenuList != null && Array.isArray(adminConsoleMenuList)
      ? adminConsoleMenuList
      : []),
  ]
}

export default function appTypeConfigFunc() {
  let appTypeInfo = {}
  try {
    appTypeInfo = JSON.parse(getEnvParam('appType') || '{}')
  } catch {
    appTypeInfo = {}
  }

  const appType = appTypeInfo.role

  if (configMap[appType] == null) {
    const config = {}

    // console에서는 workspace.role을 기준으로 구분.
    switch (appType) {
      case 'owner':
      case 'admin':
        config.menu = require('./admin/menu.ts').default
        config.router = require('./admin/router.ts').default
        config.config = require('./admin/config.ts').default
        break
      case 'user':
      default:
        config.menu = require('./user/menu.ts').default
        config.router = require('./user/router.ts').default
        config.config = require('./user/config.ts').default
    }

    configMap[appType] = config
  }

  return configMap[appType]
}
